import { InAppMessageDelayManager } from "../../delay/InAppMessageDelayManager"
import { InAppMessageDeliverProcessor } from "../../deliver/InAppMessageDeliverProcessor"
import { AbstractInAppMessageScheduler } from "./AbstractInAppMessageScheduler"
import { InAppMessageScheduleType } from "../InAppMessageScheduleType"
import { InAppMessageScheduleRequest } from "../InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "../InAppMessageScheduleResponse"
import { InAppMessageDeliverRequest } from "../../deliver/InAppMessageDeliverRequest"
import ObjectUtil from "../../../../core/internal/util/ObjectUtil"
import Logger from "../../../../core/internal/logger"

export class StoredInAppMessageScheduler extends AbstractInAppMessageScheduler {
  constructor(
    private readonly deliverProcessor: InAppMessageDeliverProcessor,
    private readonly delayManager: InAppMessageDelayManager
  ) {
    super()
  }

  /**
   * @override
   */
  supports(scheduleType: InAppMessageScheduleType): boolean {
    return scheduleType === "STORED"
  }

  /**
   * @override
   */
  deliver(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    const delay = this.delayManager.delete(request)
    ObjectUtil.requiredNotNullOrUndefined(
      delay,
      () => `InAppMessageDelay not found (inAppMessageKey=${request.schedule.inAppMessageKey})`
    )

    const deliverRequest = InAppMessageDeliverRequest.of(request)
    const deliverResponse = this.deliverProcessor.process(deliverRequest)
    return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse, delay)
  }

  /**
   * @override
   */
  delay(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    const delay = this.delayManager.delay(request)

    Logger.log.debug(
      `StoredDelay is scheduled (inAppMessageKey=${
        request.schedule.inAppMessageKey
      }, delayMillis=${request.delayMillis.toLocaleString()})`
    )
    return InAppMessageScheduleResponse.of(request, "DELAY", null, delay)
  }

  /**
   * @override
   */
  ignore(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    const delay = this.delayManager.delete(request)
    return InAppMessageScheduleResponse.of(request, "IGNORE", null, delay)
  }
}
